<template>
  <div>
    <div v-if="getTimezoneDone" style=" display: flex;">
      <LiveView
        :dateRange="dateRange"
        :stores="stores"
        :timezone="pagePreference.standardTimezone || 'America/Los_Angeles'"
        :last-refresh-ts="lastFetchAt"
        :refresh-interval-ms="15 * 1000"
      />
    </div>
    <div v-else class="analytic-loading">
      <Loading />
    </div>
  </div>
</template>

<script>
import { authService } from '@/apis/auth.s';
import Loading from '@/components/Loading';
import STORAGE_NAME from '@/const/storage';
import {
  FETCH_AOI_RATE,
  FETCH_AOV_RATE,
  FETCH_CONVERSION_RATE,
  FETCH_PAGE_PREFERRENCE,
  FETCH_TOTAL_ORDERS,
  FETCH_TOTAL_SALES,
  FETCH_REALTIME_OVERVIEW,
  FETCH_GLOBE_CHART,
} from '@/store/actions.type';
import moment from 'moment';
import LiveView from './components/LiveView.vue';

export default {
  components: {
    LiveView,
    Loading,
  },

  data: function() {
    let query = this.$route.query;
    return {
      width: 2,
      autoRefresh: query?.refresh === 'true' || false,
      refreshInterval: false,
      dateRange: {
        from: query?.from_time,
        to: query?.to_time,
      },
      stores: query?.store?.split(',') || [],
      getTimezoneDone: true,
      itemsLink: [
        { title: 'Profile', router: 'website.profile', params: {}, icon: '' },
        { title: 'Select another shop', router: 'auth', params: { authPage: 'shop' }, icon: '' },
        { title: 'Open your site', router: '', params: {}, icon: '' },
        { title: 'Logout', router: 'logout', params: {}, icon: '' },
      ],
      lastTimeReq: null,
      lastFetchAt: Date.now(),
    };
  },
  async beforeMount() {
    if (!this.pagePreference.standardTimezone) {
      this.getTimezoneDone = false;
      await this.$store.dispatch(FETCH_PAGE_PREFERRENCE);
      this.getTimezoneDone = true;
    }
  },
  created() {
    // let { autoRefresh } = this.loadQueryFromCache();
    this.lastTimeReq = Math.round((new Date().getTime() - 5 * 60 * 1000) / 1000);
    this.autoRefreshChart();
  },
  methods: {
    pickedDate(dates) {
      this.dateRange = {
        from: dates.startDate,
        to: dates.endDate,
      };
      let query = this.$route.query;
      this.updateQuery({
        stores: query?.stores,
        from_time: moment(this.dateRange.from).format('YYYY-MM-DD'),
        to_time: moment(this.dateRange.to).format('YYYY-MM-DD'),
        tz: query?.tz,
        refresh: query?.refresh,
      });
      // this.cacheQuery({ startDate: this.dateRange.from, endDate: this.dateRange.to });
    },
    onSelectedStores(stores) {
      this.stores = stores;
      let query = this.$route.query;
      this.updateQuery({
        stores: this.stores.join(','),
        from_time: query?.from_time,
        to_time: query?.to_time,
        tz: query?.tz,
        refresh: query?.refresh,
      });
      // this.cacheQuery({ stores: this.stores });
    },
    async fetchDashboardData() {
      let { stores } = this.loadQueryFromCache();

      // if (!startDate) startDate = moment().format('YYYY-MM-DD');

      // if (!endDate) endDate = moment().format('YYYY-MM-DD');
      const timezone = this.pagePreference.standardTimezone || 'America/Los_Angeles';
      const now = moment().tz(timezone);
      const today = now.format('YYYY-MM-DD');

      const start_at = this.lastTimeReq || Math.round((new Date().getTime() - 5 * 60 * 1000) / 1000);

      await Promise.all([
        this.$store.dispatch(FETCH_REALTIME_OVERVIEW),
        this.$store.dispatch(FETCH_GLOBE_CHART, start_at),
        this.$store.dispatch(FETCH_TOTAL_ORDERS, {
          fromTime: today,
          toTime: today,
          stores,
          timezone: this.pagePreference.standardTimezone || 'America/Los_Angeles',
        }),
        this.$store.dispatch(FETCH_TOTAL_SALES, {
          fromTime: today,
          toTime: today,
          stores,
          timezone: this.pagePreference.standardTimezone || 'America/Los_Angeles',
        }),
      ]);
      this.lastTimeReq = Math.round((new Date().getTime() - 5 * 60 * 1000) / 1000);
      // mark when fetch completed (ms epoch) so children can sync countdown
      this.lastFetchAt = Date.now();
    },
    autoRefreshChart() {
      this.fetchDashboardData();

      this.refreshInterval = setInterval(() => {
        this.fetchDashboardData();
      }, 15 * 1000);
    },
    // cacheQuery(args) {
    //   let currentStorageStr = localStorage.getItem(STORAGE_NAME.REPORT_SEARCH_QUERY);
    //   let currentStorage = currentStorageStr ? JSON.parse(currentStorageStr) : {};
    //   currentStorage.startDate =
    //     args && args.startDate ? moment(args.startDate).format('YYYY-MM-DD') : currentStorage.startDate;
    //   currentStorage.endDate =
    //     args && args.endDate ? moment(args.endDate).format('YYYY-MM-DD') : currentStorage.endDate;
    //   currentStorage.stores = args && args.stores ? args.stores : currentStorage.stores;
    //   currentStorage.autoRefresh = args && args.autoRefresh ? args.autoRefresh : currentStorage.autoRefresh;
    //   localStorage.removeItem(STORAGE_NAME.REPORT_SEARCH_QUERY);
    //   localStorage.setItem(STORAGE_NAME.REPORT_SEARCH_QUERY, JSON.stringify(currentStorage));
    // },
    loadQueryFromCache() {
      let cacheQuery = localStorage.getItem(STORAGE_NAME.REPORT_SEARCH_QUERY);
      return cacheQuery ? JSON.parse(cacheQuery) : {};
    },
    updateQuery(query) {
      this.$router.push({
        query: query,
      });
    },
    choseItem(item) {
      if (item.title === 'Logout') {
        try {
          authService.logout();
          localStorage.clear();
          window.location.href = this.$urlAuth;
        } catch (error) {
          console.log(error.response);
        }
      } else if (item.title === 'Open your site') {
        if (this.$store.state.auth.accountInfo.rDomain.indexOf('.dropshipx.io') > -1) {
          window.open('https://' + this.$store.state.auth.accountInfo.rDomain);
        } else {
          window.open('https://www.' + this.$store.state.auth.accountInfo.rDomain);
        }
      } else {
        this.$router.push({ name: item.router, params: item.params });
      }
      // if (item.title === 'Profile') {
      //   this.$router.push({ name: item.router, params: item.params });
      // }
      // if (item.title === 'Select another shop') {
      //   window.location.href = this.$urlAuth + 'shop';
      // }
    },
  },
  computed: {
    // ...mapGetters(['pagePreference']),
    pagePreference() {
      return this.$store.getters.pagePreference;
    },
    conversionRate() {
      return this.$store.getters.conversionRate;
    },
    user() {
      return this.$store.getters.user;
    },
    visitors() {
      return this.$store.getters.visitors || 0;
    },
    realtimeData() {
      return this.$store.getters.realtimeOverview;
    },
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },
  destroyed() {
    // No remove auto refresh
    let currentCacheQuery = this.loadQueryFromCache();
    let newCacheQuery = { autoRefresh: currentCacheQuery?.autoRefresh };
    localStorage.removeItem(STORAGE_NAME.REPORT_SEARCH_QUERY);
    localStorage.setItem(STORAGE_NAME.REPORT_SEARCH_QUERY, JSON.stringify(newCacheQuery));
  },
};
</script>

<style lang="scss" scoped></style>
